import { gql, useQuery } from "@apollo/client";
import { Rename } from "utils/typescript";
import {
  QueryUseCaseList,
  QueryUseCaseListVariables,
  QueryUseCaseList_solutions_Solutions_solution_Solution_useCases_UseCasesViewModel_useCases_UseCaseViewModel_detail_UseCaseDetail as UseCaseDetail
} from "./schema/QueryUseCaseList";

export type UseCaseType = Rename<UseCaseDetail, "key", "useCaseKey">;

export const queryUseCaseList = gql`
  query QueryUseCaseList($solutionKey: Key!) {
    solutions {
      solution(solutionKey: $solutionKey) {
        key
        useCases {
          useCases(latestVersionOnly: true) {
            detail {
              name
              image
              description
              tags
              key
              version
              transactionTable
            }
          }
        }
      }
    }
  }
`;

export default function useQueryUseCaseList(solutionKey: string) {
  return useQuery<QueryUseCaseList, QueryUseCaseListVariables>(
    queryUseCaseList,
    {
      variables: { solutionKey }
    }
  );
}
